import { render, staticRenderFns } from "./veStuStipend.vue?vue&type=template&id=2c9f1436&scoped=true"
import script from "./veStuStipend.vue?vue&type=script&lang=js"
export * from "./veStuStipend.vue?vue&type=script&lang=js"
import style0 from "./veStuStipend.vue?vue&type=style&index=0&id=2c9f1436&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9f1436",
  null
  
)

export default component.exports